import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import { AnimateSlideInContent } from './index.style'
import { useStore } from '@Store/'
import { animation } from '@styles/vars/animation.style'

const AnimateSlideIn = ({
  enterFrom = 'bottom',
  duration = 0.4,
  delay = 0,
  triggerOnce = true,
  offset = '3.2rem',
  animate = true,
  rootMargin = animation.rootMargin,
  children,
}) => {
  const [ref, inView] = useInView({
    triggerOnce,
    rootMargin,
  })

  const [store] = useStore()
  const { showPageMask } = store

  const [reveal, setReveal] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return

    let timeoutId
    let rafId

    const revealContent = () => {
      setReveal(true)
    }

    /**
     * Preferred behavior:
     * Wait until the page transition mask has finished.
     */
    if (!showPageMask) {
      rafId = window.requestAnimationFrame(revealContent)
    }

    /**
     * Fallback behavior:
     * If showPageMask gets stuck because the Layout/font lifecycle changed,
     * still reveal the content after page load.
     */
    timeoutId = window.setTimeout(revealContent, 1200)

    return () => {
      window.cancelAnimationFrame(rafId)
      window.clearTimeout(timeoutId)
    }
  }, [showPageMask])

  const shouldAnimate = inView && animate && reveal

  return (
    <AnimateSlideInContent
      ref={ref}
      inView={shouldAnimate}
      enterFrom={enterFrom}
      offset={offset}
      duration={duration}
      delay={delay}
    >
      {children}
    </AnimateSlideInContent>
  )
}

AnimateSlideIn.propTypes = {
  children: PropTypes.node.isRequired,
  delay: PropTypes.number,
  duration: PropTypes.number,
  triggerOnce: PropTypes.bool,
  animate: PropTypes.bool,
  offset: PropTypes.string,
  rootMargin: PropTypes.string,
  enterFrom: PropTypes.oneOf(['top', 'right', 'left', 'bottom']),
}

export default AnimateSlideIn